import { handleActions } from 'redux-actions';
import u from 'updeep';
import * as actions from './flpHomeActions';
 
const initialState = {
  isFetchingStaticContent: false,
  landingStaticText: {},
  isFetchingGrades: false,
  grades: {},
  isFetchingAboutContent: false,
  isFetchingSimilarGrades: false,
  similarGrades: {},
  aboutStaticText: {},
  isDownloading: false,
  isFetchingResource: false,
  resourceDetails: {},
  isFlpEnrolModalVisible: false,
  stage: '',
  story: {},
  pdf: '',
  isCheckingFlpUserEnrolled: false,
  isFetchingFlpUserEnroll: false,
  isFlpUserEnrolled: false,
  enrollmentDetails: {
    enrollmentDetails: {}
  },
  flpUserType: '',
  isFetchingStoryStatus: false,
  storyStatus: {},
  storyLabel: {},
  isSettingStoryStatus: false,
  nagCount: {},
  enrolData: null,
  showSuccessAnimation: false,
  isBaselineModalVisible: false,
  existing: false,
  isBaselineCompleted: false,
  isCertificateDownloaded: false,
  isPTCompletedArray: [],
  isJotformVisble: false,
  jotformUrl: '',
  gradeDetails: null,
  jotformType: null,
  milestoneIndex: null,
  isEndlineCompleted: false,
  isEndlineModalVisible: false,
  flpGradeFinished: false,
  isCertDownloading: false,
  worksheetDetails: [],
  jotformIndex: null,
  classroomStaticText: {},
  isFetchingStudents: false,
  students: [],
  studentClass: {},
  validateCode: null,
  flpState: null,
  allClassrooms: [],
  iisFetchingAllClassrooms: false,
  validClass: true,
  isFetchingAllFlpEnrollUser: false,
  allFlpEnrolluser: {},
  isFetchingFlpAllStories: false,
  isFetchingMoreFlpAllStories: false,
  flpAllStories: [],
  hits: 0,
  loadedPages: 0,
  oneToManyLocale: null,
  isFetchingValidate: false,
  validationErrors: null,
  isFetchingAddWorksheet: false,
  addWorksheetMsg: '',
  isFetchingViewWorksheet: false,
  worksheetQuestions: {},
  isFetchingWorksheetAns: false,
  worksheetAnswers: [],
  errorAnswers: "",
  allEnrollments: [],
  isDeletingSubmissions: false,
  deletedMsg: null
}

const statusOfEndline = (state) => {

  let status= true;      

  if(state.grades.stories) {
    for(let i = 0; i < state.grades.stories.length ; i++) {        
      if(state.storyStatus[state.grades.stories[i].id] && state.storyStatus[state.grades.stories[i].id] !== "finished") {
        status = false;
      }
    }
  }
  return status
}

export default handleActions({
  [actions.fetchFlpHomeStaticContent]: (state, action) => u({
    isFetchingStaticContent: true
  }, state),

  [actions.receiveFlpHomeStaticContent]: (state, action) => u({
    isFetchingStaticContent: false,
    landingStaticText: action.payload.data
  }, state),

  [actions.fetchFlpHomeGrades]: (state, action) => u({
    isFetchingGrades: true
  }, state),

  [actions.receiveFlpHomeGrades]: (state, action) => u({
    isFetchingGrades: false,
    grades: action.payload.data,
    showSuccessAnimation: false
  }, state),

  [actions.fetchFlpHomeSimilarGrades]: (state, action) => u({
    isFetchingSimilarGrades: true
  }, state),

  [actions.receiveFlpHomeSimilarGrades]: (state, action) => u({
    isFetchingSimilarGrades: false,
    similarGrades: action.payload.data
  }, state),

  [actions.fetchFlpHomeAboutContent]: (state, action) => u({
    isFetchingAboutContent: true,
  }, state),

  [actions.receiveFlpHomeAboutContent]: (state, action) => u({
    isFetchingAboutContent: false,
    aboutStaticText: action.payload.data
  }, state),

  [actions.fetchFlpHomeDownload]: (state, action) => u({
    isDownloading: true,
  }, state),

  [actions.receiveFlpHomeDownload]: (state, action) => u({
    isDownloading: false,
  }, state),

  [actions.flpHomeDownloadError]: (state, action) => u({
    isDownloading: false,
  }, state),

  [actions.fetchGetResourceDetail]: (state, action) => u({
    isFetchingResource: true
  }, state),

  [actions.recieveGetResourceDetail]: (state, action) => u({
    isFetchingResource: false,
    resourceDetails: action.payload.data
  }, state), 

  [actions.fetchFlpUserEnrolled]: (state, action) => u({
    isCheckingFlpUserEnrolled: true
  }, state),
//TODO: enrollmentDetails has to be modified
  [actions.receiveFlpUserEnrolled]: (state, action) => u({
      isCheckingFlpUserEnrolled: false,
      isFlpUserEnrolled: action.payload.isEnrolled,
      isBaselineCompleted: action.payload.data.baseline,
      isCertificateDownloaded: action.payload.data.isCertificateDownloaded,
      enrollmentDetails: action.payload.data ? action.payload.data.flpEnrollmentDetails : {} ,
      gradeDetails : action.payload.grade,
      isPTCompletedArray: action.payload.data.milestone,
      isEndlineCompleted: action.payload.data.endline,
      worksheetDetails: action.payload.data.worksheet,
  }, state),


  [actions.enrollFlpUserToLevel]: (state, action) => u({
    isFetchingFlpUserEnroll: true,
    showSuccessAnimation: false
  }, state),

  [actions.receiveEnrollFlpUserToLevel]: (state, action) => u({
      isFetchingFlpUserEnroll: false,
      isFlpUserEnrolled: action.payload.enrolled,
      showSuccessAnimation: true,
  }, state),

  [actions.selectFlpUserType]: (state, action) => u({
    flpUserType: action.payload,
  }, state),

  [actions.setFlpProgress]: (state, action) => u({
    flpGradeFinished: statusOfEndline(state),
  }, state),

  [actions.openFlpEnrolModal]: (state, action) => u({
    isFlpEnrolModalVisible: true,
    stage: action.payload.nag,
    story: action.payload.story,
    pdf: action.payload.pdf,
    self: action.payload.self,
    flpUserType: '',
  }, state),

  [actions.closeFlpEnrolModal]: (state, action) => u({
    isFlpEnrolModalVisible: false,
    stage: ''
  }, state),

  [actions.openBaselineModal]: (state, action) => u({
    isBaselineModalVisible: true,
    existing: action.payload.existing
  }, state),

  [actions.closeBaselineModal]: (state, action) => u({
    isBaselineModalVisible: false,
  }, state),

  [actions.openPTModal]: (state, action) => u({
    isPTModalVisible: true,
    jotformUrl: action.payload.url,
    milestoneIndex: action.payload.milestoneIndex,
  }, state),

  [actions.closePTModal]: (state, action) => u({
    isPTModalVisible: false,
  }, state),

  [actions.openEndlineModal]: (state, action) => u({
    isEndlineModalVisible: true,
  }, state),

  [actions.closeEndlineModal]: (state, action) => u({
    isEndlineModalVisible: false,
  }, state),

  [actions.openJotformModal]: (state, action) => u({
    isJotformVisble: true,
    jotformUrl: action.payload.url,
    jotformType: action.payload.type,
    jotformIndex: action.payload.jotformIndex
  }, state),

  [actions.closeJotformModal]: (state, action) => u({
    isJotformVisble: false,
  }, state),

  [actions.fetchStoryStatus]: (state, action) => u({
    isFetchingStoryStatus: true
  }, state),

  [actions.receiveStoryStatus]: (state, action) => u({
      isFetchingStoryStatus: false,
      storyStatus: action.payload.status,
      storyLabel: action.payload.label
  }, state),

  [actions.setStoryStatus]: (state, action) => u({
    isSettingStoryStatus: true
  }, state),

  [actions.receiveSetStoryStatus]: (state, action) => u({
    isSettingStoryStatus: false,
    readStoryStatus: action.payload.readStoryStatus
  }, state),

  [actions.receiveNagCount]: (state, action) => u({
    nagCount: action.payload.readCount,
    enrolData: action.payload.enrolData
  }, state),

  [actions.fetchFlpCertDownload]: (state, action) => u({
    isCertDownloading: true,
  }, state),

  [actions.recieveFlpCertDownload]: (state, action) => u({
    isCertDownloading: false,
  }, state),

  [actions.getFlpClassroomStaticContent]: (state, action) => u({
    isFetchingStaticContent: true,
  }, state),

  [actions.receiveFlpClassroomStaticContent]: (state, action) => u({
    isFetchingStaticContent: false,
    classroomStaticText: action.payload.data
  }, state),

  [actions.fetchFlpClassroomStudents]: (state, action) => u({
    isFetchingStudents: true,
  }, state),

  [actions.receiveFlpClassroomStudents]: (state, action) => u({
    isFetchingStudents: false,
    studentClass: !action.payload.error && action.payload.data.flp_classroom,
    students: !action.payload.error && action.payload.data.flp_classroom_students,
    validClass: !action.payload.error,
  }, state),

  [actions.receiveFlpValidateCode]: (state, action) => u({
    validateCode: action.payload.already_verified,
    oneToManyLocale: action.payload.locale,
    flpState: action.payload.already_verified ? action.payload.state : ""
  }, state),

  [actions.fetchFlpAllClassroom]: (state, action) => u({
    isFetchingAllClassrooms: true,
  }, state),

  [actions.receiveFlpAllClassroom]: (state, action) => u({
    isFetchingAllClassrooms: false,
    allClassrooms: action.payload.data.flp_classrooms,
  }, state),

  [actions.fetchAllFlpEnrollUser]: (state, action) => u({
    isFetchingAllFlpEnrollUser: true,
  }, state),

  [actions.receiveAllFlpEnrollUser]: (state, action) => u({
    isFetchingAllFlpEnrollUser: false,
    allFlpEnrolluser: action.payload.data,
  }, state),

  [actions.fetchFlpAllStories]: (state, action) => u({
    isFetchingFlpAllStories: true
  }, state),

  [actions.receiveFlpAllStories]: (state, action) => u({
    isFetchingFlpAllStories: false,
    flpAllStories: action.payload.data.stories,
    hits: action.payload.data.totalResults,
    loadedPages: 1
  }, state),

  [actions.fetchMoreFlpAllStories]: (state, action) => u({
    isFetchingMoreFlpAllStories: true
  }, state),

  [actions.receiveMoreFlpAllStories]: (state, action) => u({
    isFetchingMoreFlpAllStories: false,
    flpAllStories: state.flpAllStories.concat(action.payload.data.stories),
    loadedPages: state.loadedPages + 1
  }, state),

  [actions.fetchValidateWorksheet]: (state, action) => u({
    isFetchingValidate: true
  }, state),

  [actions.receiveValidateWorksheet]: (state, action) => u({
    isFetchingValidate: false,
    validationErrors: action.payload.errors,
  }, state),

  [actions.fetchAddWorksheetQuestions]: (state, action) => u({
    isFetchingAddWorksheet: true,
    addWorksheetMsg: ''
  }, state),

  [actions.receiveAddWorksheetQuestions]: (state, action) => u({
    isFetchingAddWorksheet: false,
    addWorksheetMsg: action.payload.data,
  }, state),

  [actions.fetchViewWorksheetQuestions]: (state, action) => u({
    isFetchingViewWorksheet: true
  }, state),

  [actions.receiveViewWorksheetQuestions]: (state, action) => u({
    isFetchingViewWorksheet: false,
    worksheetQuestions: action.payload.data,
  }, state),

  [actions.fetchViewWorksheetAnswers]: (state, action) => u({
    isFetchingWorksheetAns: true,
  }, state),

  [actions.receiveViewWorksheetAnswers]: (state, action) => u({
    isFetchingWorksheetAns: false,
    worksheetAnswers: action.payload.ok ? action.payload.data : [],
    errorAnswers: action.payload.ok ? "" : action.payload.data
  }, state),

  [actions.fetchAllFlpEnrollments]: (state, action) => u({
  }, state),

  [actions.receiveAllFlpEnrollments]: (state, action) => u({
    allEnrollments: action.payload.data,
  }, state),

  [actions.fetchDeleteSubmissions]: (state, action) => u({
    isDeletingSubmissions: true
  }, state),

  [actions.receiveDeleteSubmissions]: (state, action) => u({
    isDeletingSubmissions: false,
    deletedMsg: action.payload.ok ? action.payload.data : null
  }, state),

}, initialState);


// WEBPACK FOOTER //
// ./src/redux/flpHomeReducer.js